var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('admin-header',{attrs:{"title":'Port Areas',"uploader":true},on:{"open-filter":_vm.openFilter,"create-entity-request":_vm.goToNewEntityScreen,"entity-quick-search":_vm.search,"csv-upload":_vm.multiSave}}),_vm._v(" "),_c('div',{attrs:{"id":"admin-content"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ae67758","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/PortArea/AdminPortArea.vue
// module id = 1910
// module chunks = 1